import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import AppRouter from "./routes";
import "./App.css";
import { getCurrentUser } from "./api/apiUtils.js";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./utils/ScrollToTop";
import { NavigationLoadingProvider } from "./utils/NavigationLoadingContext";

function App() {
  const token = localStorage.getItem("lk_auth_token");

  useEffect(() => {
    const fetchAndSetUser = async () => {
      if (localStorage.getItem("lk-user") || !token) {
        return;
      } else {
        const userResponse = await getCurrentUser();
        if (userResponse.success) {
          localStorage.setItem("lk-user", userResponse.data);
        }
      }
    };
    fetchAndSetUser();
  }, [token]);

  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <NavigationLoadingProvider>
            <Toaster />
            <ScrollToTop />
            <AppRouter />
          </NavigationLoadingProvider>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
